import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';

//helper scripts
import * as wpScripts from '../../scripts/wpObjectScripts.js';
import StructureFoldersItem from './StructureFoldersItem.js';

const StructureFolders = ({ clang, data, type }) => {

    const boxes = data ? wpScripts.getBoxes(data.acf) : [];

    const foldersItems = boxes.map((listItem, index) => {
        return <StructureFoldersItem {...listItem} key={index} type={type}/>;
    });

    return (
      <ul className="structure__folders">
          { foldersItems }
      </ul>
    );
};

StructureFolders.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(StructureFolders);



// WEBPACK FOOTER //
// ./src/components/characteristics/StructureFolders.js